import { OnInit, OnDestroy } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiContextUtils } from '@pershing/nxi-common';
declare let dojoApp: any;

@Component({
    selector: 'dojo-manage-user',
    templateUrl: './dojo-manage-user.component.html'
})
export class DojoManageUserComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;

    acctRef: string;
    private qaInternalUrl: string;
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private paramService: NxiWidgetParamsService,
                private nxiRestService: NxiRestService) {
        this.qaInternalUrl = this.nxiRestService.serviceUrl;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getWidgetResponse();
        });
    }

    getWidgetResponse(): any {
        this.paramService.getWidgetParam('/advisorSecurity/render').subscribe(
            resp => {
                let response: any = resp.response;
                resp.response.resetPasswordUrl = this.qaInternalUrl + resp.response.resetPasswordUrl;
                resp.response.unlockPasswordUrl = this.qaInternalUrl + resp.response.unlockPasswordUrl;
                resp.response.resetSAUrl = this.qaInternalUrl + resp.response.resetSAUrl;
                resp.response.resetOTPUrl = this.qaInternalUrl + resp.response.resetOTPUrl;
                console.log('response', response);
                if (dojoApp) {
                    dojoApp.renderManageUser(response);
                }
            },
            error => {
                console.log('error', error);
                return error;
            }
        );
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('manageUser');
        }
    }

}
